var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"app-page"},[(_vm.src)?_c('viewer-pdf',{attrs:{"content":_vm.src,"id":_vm.id},on:{"loaded":_vm.onLoaded,"error":_vm.onError}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }